export default "__VITE_ASSET__C7AQw9oP__"